import { createFileRoute } from '@tanstack/react-router';

import { DashboardScreen } from '@/features/dashboard/components/DashboardScreen';

export const Route = createFileRoute('/client/dashboard')({
  component: ClientDashboardPage,
});

function ClientDashboardPage() {
  return <DashboardScreen />;
}
